import {
  Message
} from 'element-ui';
import axios from 'axios';
import '@/io/pace.min.js';

// 初始化Pace
window.paceOptions = {
  ajax: {
    trackMethods: ["GET", "POST", "DELETE", "PUT", "PATCH"]
  }
};
Pace.on("hide", () => {
  Pace.stop();
});

// 防止重复提交相同请求
let reqs = [];
let CancelToken = axios.CancelToken;

let handleReq = req => {
  let position;
  reqs.forEach((value, index) => {
    if (value.url === req.url && value.method === req.method && JSON.stringify(value.params) === JSON.stringify(req.params)) {
      position = index;
    }
  });
  if (typeof position === 'number') {
    if (req.cancel) {
      Message.warning('请稍等，拼命处理中');
      req.cancel();
    } else {
      reqs.splice(position, 1);
    }
  } else {
    reqs.push(req);
  }
};

axios.interceptors.request.use(
  (config) => {
    config.cancelToken = new CancelToken(cancel => {
      handleReq({
        url: config.url,
        method: config.method,
        params: config.params,
        cancel
      });
    });
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  res => {
    handleReq(res.config);
    if (res.data.code != 200) {
      let code = res.data.code;
      if (code === 200201) {
        Message.error('验证码过期');
      } else if (code === 200202) {
        Message.error('验证码错误');
      } else if (code === 200005) {
        Message.error('手机号尚未注册');
      } else if (code === 200015) {
        Message.error('该标签下有员工，无法删除');
      } else if (code === 200001) {
        Message.error('授权失败');
      } else if (code === 200009) {
        Message.error('该账户无权访问');
      } else if (code === 200901) {
        Message.error('图片未检测出人脸，请重新上传');
      }
      return Promise.reject(res);
    } else {
      return res.data;
    }
  },
  (err) => {
    handleReq(err.config);
    return Promise.reject(err);
  }
);